/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { LoadingState } from "@microsoft/shifts-models-view";

import { EntityListState } from "./EntityListState";

/**
 * Creates a state for loading a list of entities using generic store.
 * @returns The created state for loading a list of entities using generic store.
 */
export function createEntityListState<TEntity>(): EntityListState<TEntity> {
    return {
        error: undefined,
        loadingState: LoadingState.NotStarted,
        values: undefined
    };
}
